var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"time"},[_c('div',{style:({ width: _vm.width + 'px', height: _vm.height + 'px',background:_vm.bColor, }),attrs:{"id":"timebox"},on:{"click":_vm.changeColor}})])
}
var staticRenderFns = []

export { render, staticRenderFns }